// Modules
import { Modal } from '@dasa-health/components-react'
import styled from 'styled-components'

export const CustomModal = styled(Modal)`
    &&& {
        padding-top: 24px;
        border-radius: 16px;
        height: 505px;
        width: 505px;
    }
`

export const ModalContent = styled.div`
    height: 505px;
    width: 505px;
    padding: 32px;
`

export const FirstTitle = styled.h1`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0px;
    text-align: left;

    margin: 24px 0 8px 0;
`

export const FirstSubtitle = styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
`
export const SecondTitle = styled.h2`
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;

    margin: 24px 0 8px 0;
`
export const SecondSubtitle = styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
`
export const BottomSheetContent = styled.div`
    padding: 24px;
`

export const BottomSheetTitle = styled.h1`
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;

    margin-bottom: 8px;
`

export const BottomSheetSubtitle = styled.h1`
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;

    margin-bottom: 8px;
`
